import React, { Dispatch, SetStateAction, useState } from 'react';
import moment from 'moment';
import getHostName from 'helpers/getHostName';
import * as Types from 'pages/Pages/typings';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

interface Props {
  deletable: boolean;
  classes: any;
  page: Types.Entity;
  isIndependentPage: boolean;
  onDelete: () => void;
  handleSelectEntity: Dispatch<SetStateAction<Types.Entity | null>>;
}

function PagesRow({
  deletable,
  classes,
  page,
  isIndependentPage,
  onDelete,
  handleSelectEntity,
}: Props) {
  const hostName = getHostName();
  const subdomain = window.location.host.split('.')[0];
  const subdomainUrl = subdomain.includes('localhost') ? 'test-development' : subdomain;
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMore = (event: React.MouseEvent<HTMLElement>, page: Types.Entity) => {
    setMenuOpen(!menuOpen);
    handleSelectEntity(page);
    setAnchorEl(event ? event.currentTarget : anchorEl);
  };

  const handleDelete = () => {
    onDelete();
    setMenuOpen(false);
  };

  return (
    <TableRow data-testid={`${page.name}-row`}>
      <TableCell>
        <a
          className={classes.pageLink}
          href={`http://${subdomainUrl}.${hostName}.com/entities/${page.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {page.name}
        </a>
      </TableCell>
      <TableCell>{page.metadata.explicitEditorCount}</TableCell>
      {!isIndependentPage && <TableCell>{page.metadata.memberCount}</TableCell>}
      <TableCell>
        {page.metadata.lastEditedAt ? moment(page.metadata.lastEditedAt).format('MM/DD/YYYY') : '-'}
      </TableCell>
      {deletable ? (
        <TableCell className={classes.textAlignRight} size="small">
          <IconButton
            aria-label="More"
            aria-haspopup="true"
            onClick={(event: React.MouseEvent<HTMLElement>) => handleMore(event, page)}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={menuOpen} onClose={() => setMenuOpen(false)}>
            <MenuItem onClick={handleDelete}>Delete Page</MenuItem>
          </Menu>
        </TableCell>
      ) : (
        <TableCell />
      )}
    </TableRow>
  );
}

export default PagesRow;
